import script from "./DogCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DogCard.vue?vue&type=script&setup=true&lang=js"

import "./DogCard.vue?vue&type=style&index=0&id=0c2c3ea2&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2c3ea2"]])

export default __exports__